// src/components/ToastMessage.js
import React, { useEffect, useState } from 'react';

function ToastMessage({ type, message }) {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setShow(false), 4000); // auto-close after 4s
        return () => clearTimeout(timer);
    }, []);

    if (!show || !message) return null;

    const bgClass = type === 'success' ? 'bg-success text-white' : 'bg-danger text-white';

    return (
        <div
            className="toast-container position-fixed bottom-0 end-0 p-3"
            style={{ zIndex: 9999 }}
        >
            <div className={`toast show ${bgClass}`} role="alert" aria-live="assertive" aria-atomic="true">
                <div className="d-flex">
                    <div className="toast-body">{message}</div>
                    <button
                        type="button"
                        className="btn-close btn-close-white me-2 m-auto"
                        onClick={() => setShow(false)}
                        aria-label="Close"
                    ></button>
                </div>
            </div>
        </div>
    );
}

export default ToastMessage;
